//Ordenes de compra y solicitudes Repositorio
export const payOrdersAdapter = (orders) => {
    return orders.map((order) => ({
        id: order.id,
        name: order.name,
        createDate: order.create_order,
        estimatedPaymentDate: order.estimated_payment_date,
        paymentMethod: order.payment_method_id,
        currency: order.currency,
        state: order.state,
        responsible: order.responsible,
        amount: order.amount,
        ref: order.ref || '-',
        purchaseOrders: order.purchase_orders.map((po) => ({
            id: po.id,
            name: po.name,
            date: po.date_order,
            activityDate: po.activity_date,
            ref: po.ref,
            amount: po.amount,
            currency: po.currency,
            company: po.company,
            responsible: po.responsible,
            paymentDate: po.payment_date,
            effectivePaymentDate: po.effective_date_of_payment,
            state: po.state,
        })),
        extraProducts: (order.extra_products || []).map((prod) => ({
            product: prod.product,
            description: prod.description,
            qty: prod.qty,
            price: prod.price_unit,
            subtotal: prod.subtotal,
        })),
    }));
};
